import { useCallback, useState } from "react"

export function useKMZParser() {
  const [geoJsonData, setGeoJsonData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const parseKMZFile = useCallback(async (file: File) => {
    try {
      setLoading(true)
      setError(null)
      if (!window.GeoKMZer || !window.GeoKMLer) {
        throw new Error("GeoKMZer/GeoKMLer not loaded")
      }

      const arrayBuffer = await file.arrayBuffer()
      const geoKMZer = new window.GeoKMZer()
      const geoKMLer = new window.GeoKMLer()

      const kmlContents = await geoKMZer.read(arrayBuffer)
      const features: any[] = []

      for (const { content } of kmlContents) {
        const kmlDoc = geoKMLer.read(content)
        const geoJson = geoKMLer.toGeoJSON(kmlDoc)
        if (geoJson.features) features.push(...geoJson.features)
      }

      const result = { type: "FeatureCollection", features }
      console.log("KMZ contents:", kmlContents)
      console.log("GeoJSON features:", features)
      setGeoJsonData(result)
      return result
    } catch (err) {
      console.error(err)
      alert(err instanceof Error ? err.message : "Parse failed")
      return null
    } finally {
      setLoading(false)
    }
  }, []) // No dependencies – this function never needs to change

  const loadStaticKMZ = useCallback(async (url: string) => {
    console.log("loadStaticKMZ called with url:", url)

    try {
      setLoading(true)
      const res = await fetch(url)
      console.log("Fetch response status:", res.status)

      const buf = await res.arrayBuffer()
      const geoKMZer = new window.GeoKMZer()
      const geoKMLer = new window.GeoKMLer()
      const kmlContents = await geoKMZer.read(buf)
      const features: any[] = []
      for (const { content } of kmlContents) {
        const kmlDoc = geoKMLer.read(content)
        const geoJson = geoKMLer.toGeoJSON(kmlDoc)
        if (geoJson.features) features.push(...geoJson.features)
      }
      const result = { type: "FeatureCollection", features }
      setGeoJsonData(result)
      return result
    } catch (err) {
      console.error("loadStaticKMZ error:", err)
      // alert("Failed to load static KMZ")
      return null
    } finally {
      setLoading(false)
    }
  }, []) // Stable reference

  return { geoJsonData, loading, error, parseKMZFile, loadStaticKMZ }
}
